import getRuleError from "../../../../bootstrap/components/custom-form/error-checking/utils/getRuleError";
import getRuleValue from "../../../../bootstrap/components/custom-form/error-checking/utils/getRuleValue";
import getRequiredError from "../../../../bootstrap/components/custom-form/error-checking/utils/getRequiredError";
import __ from '../../../i18n';

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired() || checkMinLength() || checkMaxLength();
}

function checkRequired() {
    if ($value !== null) {
        return null;
    }

    return getRequiredError($rules, $options, $allValues);
}

function checkMinLength() {
    const {minLength} = $rules;

    if ($value === null || minLength === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(minLength, $allValues);

    if ($value.length >= ruleValue) {
        return null;
    }

    return getRuleError(minLength, $allValues, __('Min: :number characters', {number: ruleValue}));
}

function checkMaxLength() {
    const {maxLength} = $rules;

    if ($value === null || maxLength === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(maxLength, $allValues);

    if ($value.length <= ruleValue) {
        return null;
    }

    return getRuleError(maxLength, $allValues, __('Max: :number characters', {number: ruleValue}));
}
